<template>
  <div class="wl-certify-draw-wrapper">
    <p>绘制证书</p>
    <canvas id="canvas" class="cerfity-draw-main" ref="canvas" width="530px" height="720px"></canvas>
  </div>
</template>

<script>
export default {
  data() {
    return {
      certifyInfo: {
        name: "张三",
        startTime1: "2019年6月4日",
        endTime1: "2019年7月1日",
        trainCon:
          "1+X证书制度物流管理职业技能等级证书师资培训（中级），共计40学时",
        cerfityName: "物流管理职业技能等级证书培训教师（中级）",
        startTime2: "2019年8月1日",
        endTime2: "2022年9月4日",
        company: "北京中物联采购培训中心",
        time: "2019年8月1日",
        avatar: require("assets/images/hn-user-avatar-img.jpeg"),
        idNum: "340421199304134321",
        certifyNum: "4345143625"
      }
    };
  },
  mounted() {
    this.startDraw();
  },
  methods: {
    startDraw() {
      let canvas = this.$refs.canvas;
      let ctx = canvas.getContext("2d");
      ctx.font = "30px SourceHanSansSC-Medium";
      ctx.fillStyle = 'red';
      ctx.fillText("培训教师聘书", 170, 60);
    }
  }
};
</script>

<style lang="scss">
.wl-certify-draw-wrapper {
  margin: 0 auto;
  width: 1200px;
  text-align: center;
  .cerfity-draw-main {
    margin-top: 40px;
    border: 1px solid #999;
  }
}
</style>
